/* istanbul ignore file */
import $http from '@vue-util/http';

import { getItemNumberParams } from './WidgetUtil';

/**
 * @typedef {Object} OutfitsAvailabilityStatusParams
 * @property {string} brand - the current brand passed by PDP
 * @property {string} itemNumber - the composite item identifier (productId + color)
 * @property {number} productId - the product id
 */

const config = {
  paths: {
    product: '/xapi/digital/v1/product',
    styliticsApiOutfits: 'https://widget-api.stylitics.com/api/outfits',
  },
};

const headers = {
  'Content-Type': 'application/json',
};

export const getXapiProduct = (productId) => {
  const url = `${config.paths.product}/${productId}`;
  return $http.get(url, { headers }).then((res) => res.data);
};

/**
 * Returns a boolean indicating if the product has outfits
 * @param {OutfitsAvailabilityStatusParams} params
 * @returns {boolean}
*/
export const getOutfitsAvailabilityStatus = async ({
  brand,
  featureFlags,
  itemNumber,
  productId,
}) => {
  try {
    const itemNumberParams = getItemNumberParams({ featureFlags, itemNumber, productId });
    const { data } = await $http.get(
      config.paths.styliticsApiOutfits,
      {
        headers,
        params: {
          username: brand === 'bcom' ? 'bloomingdales' : 'macys',
          ...itemNumberParams,
        },
      },
    );
    return !!data.length;
  } catch (err) {
    // eslint-disable-next-line
    console.warn('Outfitting: Unable to request outfits');
    // Return false if any error returned from Stylitics api
    return false;
  }
};
